import React, { useState, useEffect } from 'react';
import './Styles/AnalyticsMain.css';
import SPDetail from '../../Components/AnalyticsPage/SPDetail';
import { useSelector } from 'react-redux';
import { DataApi } from '../../API';
import { useLoadingState } from '../../context/LoadingContext';

function AnalyticsStartPage(props) {
  props.setCurrentPage(props.pageTitle);
  const [, setLoading] = useLoadingState();
  const currentSite = useSelector((state) => state.currentSite);
  const period = useSelector((state) => state.period);
  const comparePeriod = useSelector((state) => state.comparePeriod);
  const [data, setData] = useState([]);
  useEffect(() => {
    try {
      setLoading(true);
      const getApi = async () => {
        const data = await DataApi.getStartPage(
          currentSite.script_code,
          period,
          comparePeriod
        );
        setData(data);
      };
      getApi();
    } catch (e) {
      console.error(e.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [currentSite, period, comparePeriod]);
  return (
    <>
      <SPDetail data={data} />
    </>
  );
}

export default AnalyticsStartPage;
